module.exports = __webpack_public_path__ + "img/ico-main-search.ed12583b.svg";